import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <div
      data-testid="page-not-found"
      className="min-h-[80vh] flex items-center justify-center bg-[#FDFCFB] px-6"
    >
      <div className="text-center max-w-lg">
        <p className="text-xs tracking-[0.35em] uppercase text-[#7B8E76] mb-6">
          Not found
        </p>
        <h1 className="font-serif text-5xl md:text-6xl text-[#2D3A2B] leading-tight">
          This path is <span className="italic">quiet</span> today.
        </h1>
        <p className="mt-6 text-[#4A5D46] font-light">
          Let&rsquo;s guide you back to the sanctuary.
        </p>
        <div className="mt-10">
          <Link to="/" data-testid="notfound-home-link">
            <Button className="rounded-full bg-[#8A9A83] hover:bg-[#7B8E76] text-white px-8 py-6 h-auto">
              Return Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
